export default "__VITE_ASSET__CjzIZsrE__"